import { render, staticRenderFns } from "./DeviceAlarms.vue?vue&type=template&id=553a8311&scoped=true&"
import script from "./DeviceAlarms.vue?vue&type=script&lang=js&"
export * from "./DeviceAlarms.vue?vue&type=script&lang=js&"
import style0 from "./DeviceAlarms.vue?vue&type=style&index=0&id=553a8311&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553a8311",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('553a8311')) {
      api.createRecord('553a8311', component.options)
    } else {
      api.reload('553a8311', component.options)
    }
    module.hot.accept("./DeviceAlarms.vue?vue&type=template&id=553a8311&scoped=true&", function () {
      api.rerender('553a8311', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/device/DeviceAlarms.vue"
export default component.exports